const breakpoints = {
  values: {
    xs: 0,
    xm: 375,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1440,
  },
};

export default breakpoints;
